export const comments_5089933 = {"data":{"data":[],"links":{}}}